/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signing_Pick_DocumentInputs */

const cs_signing_pick_document = /** @type {(inputs: Signing_Pick_DocumentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dokument`)
};

const en_signing_pick_document = /** @type {(inputs: Signing_Pick_DocumentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Document`)
};

/**
* | output |
* | --- |
* | "Document" |
*
* @param {Signing_Pick_DocumentInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const signing_pick_document = /** @type {((inputs?: Signing_Pick_DocumentInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signing_Pick_DocumentInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_signing_pick_document(inputs)
	return cs_signing_pick_document(inputs)
});